export const categoryOptions = [
  'Forex Trading',
  'Money Management',
  'Risk Management',
  'Technical Analysis',
  'Fundamental Analysis',
];

export const languageOptions = ['Sinhala', 'English'];

export const riskLevelItem = [
  { label: 'Star 1', value: '1' },
  { label: 'Star 2', value: '2' },
  { label: 'Star 3', value: '3' },
  { label: 'Star 4', value: '4' },
  { label: 'Star 5', value: '5' },
];

export const currencyItem = [
  { label: 'Euro to US Dollar (EUR/USD)', value: 'EUR/USD' },
  { label: 'British Pound to US Dollar (GBP/USD)', value: 'GBP/USD' },
  { label: 'US Dollar to Japanese Yen (USD/JPY)', value: 'USD/JPY' },
  { label: 'Australian Dollar to US Dollar (AUD/USD)', value: 'AUD/USD' },
  { label: 'US Dollar to Swiss Franc (USD/CHF)', value: 'USD/CHF' },
  { label: 'Canadian Dollar to US Dollar (CAD/USD)', value: 'CAD/USD' },
  { label: 'New Zealand Dollar to US Dollar (NZD/USD)', value: 'NZD/USD' },
  { label: 'US Dollar to Mexican Peso (USD/MXN)', value: 'USD/MXN' },
  { label: 'Euro to British Pound (EUR/GBP)', value: 'EUR/GBP' },
  { label: 'Euro to Japanese Yen (EUR/JPY)', value: 'EUR/JPY' },
  { label: 'Euro to Swiss Franc (EUR/CHF)', value: 'EUR/CHF' },
  { label: 'British Pound to Japanese Yen (GBP/JPY)', value: 'GBP/JPY' },

  // Cryptocurrencies
  { label: 'Bitcoin (BTC)', value: 'BTC' },
  { label: 'Ethereum (ETH)', value: 'ETH' },
  { label: 'Binance Coin (BNB)', value: 'BNB' },
  { label: 'Tether (USDT)', value: 'USDT' },
  { label: 'USD Coin (USDC)', value: 'USDC' },
  { label: 'XRP (Ripple) (XRP)', value: 'XRP' },
  { label: 'Cardano (ADA)', value: 'ADA' },
  { label: 'Solana (SOL)', value: 'SOL' },
  { label: 'Polkadot (DOT)', value: 'DOT' },
  { label: 'Dogecoin (DOGE)', value: 'DOGE' },
  { label: 'Shiba Inu (SHIB)', value: 'SHIB' },
  { label: 'Litecoin (LTC)', value: 'LTC' },
  { label: 'Chainlink (LINK)', value: 'LINK' },
  { label: 'Avalanche (AVAX)', value: 'AVAX' },
  { label: 'Polygon (MATIC)', value: 'MATIC' },
  { label: 'Uniswap (UNI)', value: 'UNI' },
  { label: 'Bitcoin Cash (BCH)', value: 'BCH' },
  { label: 'Terra (LUNA)', value: 'LUNA' },
  { label: 'Fantom (FTM)', value: 'FTM' },
  { label: 'VeChain (VET)', value: 'VET' },
  { label: 'Cosmos (ATOM)', value: 'ATOM' },

  // Commodities
  { label: 'Gold (XAU/USD)', value: 'XAU/USD' },
  { label: 'Silver (XAG/USD)', value: 'XAG/USD' },
  { label: 'Crude Oil (WTI)', value: 'WTI' },
  { label: 'Brent Oil (BRENT)', value: 'BRENT' },
  { label: 'Copper (COPPER)', value: 'COPPER' },
  { label: 'Platinum (XPT/USD)', value: 'XPT/USD' },
  { label: 'Palladium (XPD/USD)', value: 'XPD/USD' },
];
